import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });
export const publicApi = axios.create({ baseURL: `${API}/public` });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("bf_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const orig = err.config || {};
    const rt = localStorage.getItem("bf_refresh");
    if (err.response?.status === 401 && !orig._retry && !String(orig.url).includes("/auth/") && rt) {
      orig._retry = true;
      try {
        refreshing = refreshing || axios.post(`${API}/auth/refresh`, { refresh_token: rt }, { withCredentials: true });
        const { data } = await refreshing;
        refreshing = null;
        localStorage.setItem("bf_token", data.access_token);
        return api(orig);
      } catch (e) {
        refreshing = null;
        localStorage.removeItem("bf_token");
        localStorage.removeItem("bf_refresh");
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

const GATEWAY = [502, 503, 504, 520, 521, 522, 523, 524, 525, 526, 530];
export const errMsg = (e) => {
  if (e?.response && GATEWAY.includes(e.response.status)) return "The server is restarting or not reachable right now. Please wait a minute and try again.";
  return e?.response ? formatApiErrorDetail(e.response.data?.detail) : e?.message || "Network error";
};
